import type { AxiosRequestConfig } from 'axios';

export function isLockedSmsRequest(config: AxiosRequestConfig): boolean {
  const smsRequest = config.url?.includes('sms_authentication');

  if (!smsRequest) {
    return false;
  }

  let count = Number(localStorage.getItem('c') ?? 0);
  const lastRequestDate = localStorage.getItem('lrd') ?? new Date();
  const lockedDate = localStorage.getItem('d') ?? null;
  const refreshCount =
    new Date().getTime() - new Date(lastRequestDate).getTime() >= 3.6e6;
  const allowedTryCounts = 3;

  if (refreshCount) {
    localStorage.setItem('c', '1');
  } else {
    count = count + 1;
    localStorage.setItem('c', count.toString());
  }

  const isLockTimeExpired = lockedDate
    ? new Date().getTime() - new Date(lockedDate).getTime() >= 4.32e7
    : true;
  const isExcessOfRequests = count > allowedTryCounts;

  if (isExcessOfRequests || !isLockTimeExpired) {
    handleRequestLock({ count, lockedDate });
    return true;
  } else {
    handleRequest(lockedDate);
    return false;
  }
}

function handleRequestLock({
  count,
  lockedDate,
}: {
  count: number;
  lockedDate: string | null;
}): void {
  if (count) {
    localStorage.removeItem('c');
  }
  if (!lockedDate) {
    localStorage.setItem('d', new Date().toString());
  }
}

function handleRequest(lockedDate: string | null): void {
  if (lockedDate) {
    localStorage.removeItem('d');
  }
  localStorage.setItem('lrd', new Date().toString());
}
